import { useState, useEffect } from "react";
import {Routes, Route} from "react-router";
import Bwg800 from './Bwg800.tsx';
import Hexagon from "./Hexagon.tsx";
import env from "react-dotenv";

const TemplateStage = () => {
    const [userData, SetUD] = useState(undefined);
    const body = document.getElementsByTagName("body")[0]
    const [width, SetWidth] = useState(body.offsetHeight < body.offsetWidth ? "66vh" : "90vw");
    const BH = env.REACT_APP_ENV === "PROD" ? env.REACT_APP_BH_PROD : env.REACT_APP_BH_DEV

    useEffect(() => {

        const fetchProfiles = async () => {
            try {
                const resp = await fetch(BH + "/get-user-details");
                const results = await resp.json();
                console.log(results);
                SetUD(results);
            }
            catch (error) {
                alert(error);
            }
        }
        fetchProfiles();
        SetWidth(width);

    }, [SetUD, BH, width]);

    return (
        <div className="GradientBackGround" style={{ overflowX: "hidden" }}>
            <div className="">
                <h3 className="CenterText">
                    Select Profile
                </h3>
                {
                    userData === undefined ?
                        <p className="CenterText">
                            Sign up to use profiles. Fill once, use with any template.
                        </p>
                        :
                        <p>
                            Profiles
                        </p>
                }
            </div>

            <div className="Center" style={{ width: "100vw", overflowX: "scroll", overflowY: "hidden" }}>
                <div style={{ width: "100vw" }} className="Center Horizontally">
                    {
                        userData !== undefined &&
                        <>
                            <div style={{ width: width }} id="resume">

                                <Routes>
                                    <Route path = "/bwg800" element= {<Bwg800 param={{ 'userData': userData }} />} />
                                    <Route path= "/hexagon" element = {<Hexagon param={{ 'userData': userData, "width" : width }} />} />
                                </Routes>
                                <br /><br /><br />
                            </div>
                        </>
                    }

                </div>
            </div>

            <br />
        </div>
    )
}

export default TemplateStage;